import { render } from "./NftChooseToSubmit.vue?vue&type=template&id=ace09dd8&scoped=true"
import script from "./NftChooseToSubmit.vue?vue&type=script&lang=js"
export * from "./NftChooseToSubmit.vue?vue&type=script&lang=js"

import "@/Common/Styles/chooseToDepositNft.scss?vue&type=style&index=0&id=ace09dd8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace09dd8"]])

export default __exports__